
    var riot = require('riot')
    riot.tag2('gb-variant-switcher', '<a if="{$product.variants.length > 1}" each="{variant, i in $product.variants}" class="gb-product__variant-link" onclick="{$product.switchVariant}" data-index="{i}"> {i} </a>', 'gb-variant-switcher a,[data-is="gb-variant-switcher"] a{ cursor: pointer; }', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/product/gb-variant-switcher.tag.html